module.exports = __webpack_public_path__ + "static/img/12bg_4.4e31cdc.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/background/12bg_4.png
// module id = 634
// module chunks = 1